import React, { useEffect } from "react";
import ManageServiceUsersContainer from "../../containers/ManageServiceUsersContainer/ManageServiceUsersContainer";

export default function ManageServiceUsersPage(props: any) {
  return (
    <>
      <ManageServiceUsersContainer collapsed={props.collapsed} match={props.match} />
    </>
  );
}
